import React from 'react';
import I18n from 'i18n-js';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { gql } from '@reverbdotcom/commons/src/gql';

import { CSP } from '@reverbdotcom/commons/src/gql/graphql';
import { Paths } from './shared/url_helpers';
import { RCCard, RCFlex, RCIcon, RCText, useMediaQuery } from '@reverbdotcom/cadence/components';
import { ArrowRightIcon, StorefrontIcon } from '@reverbdotcom/cadence/icons/react';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

interface Props {
  csp: CSP;
}

export const SellOrTradeInCTAFragment = gql(`
  fragment SellOrTradeInCTAData on CSP {
    _id
    isTradeInEligible
  }
`);

export default function SellOrTradeInCTA(props: Props) {
  const isMobile = useMediaQuery('mobile');
  const { csp } = props;

  if (!csp) {
    return null;
  }

  const { id } = csp;
  const ctaPath = csp.isTradeInEligible ? Paths.listingOptions.expand({ seed_id: id }) : Paths.prefilledListingFromCSP.expand({ seed_id: id });
  const title = csp.isTradeInEligible ? I18n.t('discovery.sellOrTradeInCTA.tradeInTitle') : I18n.t('discovery.sellOrTradeInCTA.sellYoursTitle');

  const body = () => {
    if (csp.isTradeInEligible) {
      return (
        <>
          <span style={{ color: 'var(--rc-color-text-loud)' }}>{I18n.t('discovery.sellOrTradeInCTA.tradeInEligible')}</span>
          &nbsp;
          <span>{I18n.t('discovery.sellOrTradeInCTA.noFees')}</span>
        </>
      );
    } else {
      return (
        <span>{I18n.t('discovery.sellOrTradeInCTA.makeRoom')}</span>
      );
    }
  };

  return (
    <RCCard>
      <RCCard.LinkWrapper>
        <CoreLink
          to={ctaPath}
          className="color-primary"
          clickEvent={{
            eventName: MParticleEventName.ClickedComponent,
            componentName: 'SellOrTradeInCTA',
            entityType: 'url',
            entityId: ctaPath,
            tradeInEligible: csp.isTradeInEligible,
          }}
        >
          <div className="padding-4 color-primary">
            <RCFlex gap="4" justify="space-between" direction="row">
              <RCFlex gap="3" justify="space-between" direction={isMobile ? 'col' : 'row'}>
                <div className="fx-align-self-start">
                  <RCIcon size="native" svgComponent={StorefrontIcon} />
                </div>

                <RCFlex gap="3" justify="space-between">
                  <RCFlex gap="2" direction="col">
                    <RCText.Utility size="450" weight="bold">{title}</RCText.Utility>
                    <div>
                      {body()}
                    </div>
                  </RCFlex>
                </RCFlex>
              </RCFlex>

              <RCIcon size="native" svgComponent={ArrowRightIcon} />
            </RCFlex>
          </div>
        </CoreLink>
      </RCCard.LinkWrapper>
    </RCCard>
  );
}
